import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IAccount } from "../models/account.model";
import { ResponseModel } from "src/app/shared/interfaces/response-model";

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.cmsBaseUrl}/api/${environment.anqCmsVersion}/Account`;

  getOneAccount(userAuthId?: string): Observable<ResponseModel<IAccount>> {
    let params = new HttpParams();
    if (userAuthId) {
      params = params.set('userAuthId', userAuthId);
    }
    return this.http.get<ResponseModel<IAccount>>(`${this.baseUrl}/GetOneAccount`, { params });
  }
}
